import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private loading = new Subject<boolean>();
  loading$ = this.loading.asObservable();
  load(load: boolean) {
    this.loading.next(load);
  }
}
